"use client";

// Mini-Router abstraction to mimic Next.js Router
class Router {
	push(url: URL | string) {
		url = url instanceof URL ? url.toString() : url;

		if (window) {
			console.log(`[ROUTER] Navigating to ${url}`);
			window.location.href = url;
		}
	}
}

export const router = new Router();
